import VJsoneditor from './components/VJsoneditor';

export default VJsoneditor;



// WEBPACK FOOTER //
// ./src/lib.js